import {globalStore} from '../../main.js'

export default {
  name: 'dashboard',
  data() {
    return {
      isSideBarActive: true
    }
  },
  beforeCreate: function () {
    if (!this.$session.exists()) {
      this.$router.push('login')
    }
  },
  methods: {
    showSideBar: function(){
        this.isSideBarActive = !this.isSideBarActive
      },
    collapseElement: function(event, elName){
      event.preventDefault();
      if(event.currentTarget.className.indexOf("collapsed")){
        event.currentTarget.classList.remove("collapsed");
        event.currentTarget.classList.add("collapse");
        this.$refs[elName].classList.add("in");
      }
      else {
        event.currentTarget.classList.remove("collapse");
        event.currentTarget.classList.add("collapsed");
        this.$refs[elName].classList.remove("in");
      }
    },
    showChangePassword: function(event, text, subText){
      globalStore.showChangePassword(event, text, subText, this.$router);
    },
    showUsersList: function(event, text, subText){
      globalStore.showUsersList(event, text, subText, this.$router);
    },
    showDashboard: function(event){
      globalStore.openedPoint = this.actionText;
      globalStore.openedSubPoint = this.homeText;
    }
  },
  computed: {
      isFiltersActive: function(){
          return globalStore.isFiltersActive;
      },
      isCurrentUserAdmin: function(){
          return globalStore.isCurrentUserAdmin;
      },
      activeClass: function () {
        return {
          'sidebar-active': this.isSideBarActive,
          'sidebar-deactive': !this.isSideBarActive,
          'filter-active': this.isFiltersActive,
          'filter-deactive': !this.isFiltersActive
        }
      },
      openedPoint: function() {
        return globalStore.openedPoint;
      },
      openedSubPoint: function() {
        return globalStore.openedSubPoint;
      },
      isChangePassword: function() {
        return globalStore.openedSubPoint == this.changePasswordText
      },
      isUsersList: function() {
        return globalStore.openedSubPoint == this.usersListText
      },
      isDashboard: function() {
        return globalStore.openedSubPoint == this.homeText
      },
      actionText: function() {
        return this.labels.ACTION_TEXT
      },
      changePasswordText: function() {
        return this.labels.CHANGE_PASSWORD_TEXT
      }, 
      usersListText: function() {
        return this.labels.USERS_LIST_TEXT
      },
      homeText: function() {
        return this.isCurrentUserAdmin ? this.labels.APPLICATIONS_TEXT : this.labels.MY_APPLICATIONS_TEXT;
      },
      labels: function() {
          return globalStore.culture.strings.Dashboard;
      }
    },
    watch:{
      homeText: function() {
        globalStore.openedSubPoint = this.$children[0] ? this.$children[0].openedSubPoint : ''
      },
      changePasswordText : function() {
        globalStore.openedSubPoint = this.$children[0] ? this.$children[0].openedSubPoint : ''
      },
      actionText : function() {
        globalStore.openedPoint = this.$children[0] ? this.$children[0].openedPoint : ''
      }
    }
}



// WEBPACK FOOTER //
// ./src/components/Dashboard/Dashboard.js